import React, { FunctionComponent } from "react";

const About: FunctionComponent = () => {
  return <span>About</span>;
};

export default About;
